/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_SidebarInputs */

const en_shortcut_sidebar = /** @type {(inputs: Shortcut_SidebarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collapse or expand the sidebar`)
};

/**
* | output |
* | --- |
* | "Collapse or expand the sidebar" |
*
* @param {Shortcut_SidebarInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const shortcut_sidebar = /** @type {((inputs?: Shortcut_SidebarInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_SidebarInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_shortcut_sidebar(inputs)
});